import React from 'react';
import PopUp from './PopUp';

const ModuleIntroPopUp = ({ moduleTitle, listItems, timeEstimate }) => {
  const [opened, setOpened] = React.useState(true);

  const onClose = () => {
    setOpened(false);
  };

  return (
    <PopUp header={moduleTitle} opened={opened} onClose={onClose}>
      <ul className='pl-6 space-y-2'>
        {listItems.map((item, index) => (
          <li key={index}>✅ {item}</li>
        ))}
      </ul>
      <p
        className='text-center
      font-bold
      '
      >
        This module should take about {timeEstimate}.
      </p>
    </PopUp>
  );
};

export default ModuleIntroPopUp;
